__turbopack_context__.v({
  "rainCanvas": "fnMdXG_rainCanvas",
  "rainCanvasWrapper": "fnMdXG_rainCanvasWrapper",
});
